import { Context } from '@vue-storefront/core';
import { ApiResult, SubscribeItem } from '../../types';

export default async function subscribeList({ client, config }: Context): Promise<ApiResult> {
  const param = {
  };
  const url = new URL('/mall/subscribes/list', config.api.url);
  const { data: res } = await client.post(url.href, param);
  if (res.code === 0) {
    const data = res.data.result;
    const item: SubscribeItem = {
      id: data.id,
      shopId: data.shop_id,
      memberId: data.member_id,
      email: data.email,
      createTime: data.create_time
    };
    res.data = item;
  }
  return res;
}
